<template>
  <section
    class="section table-plan"
    :class="{ 'mb-tb': $route.name == 'plans' }"
  >
    <modal
      name="tooltip-mobile-modal"
      @before-open="setModalText"
      width="320px"
      height="auto"
      adapt
    >
      <div class="modal-content">
        <p>
          {{ textModal }}
        </p>
      </div>
    </modal>
    <svg class="svg-hidden" width="0" height="0">
      <defs>
        <clipPath id="clipPlan" clipPathUnits="objectBoundingBox">
          <path d="M 0 0 H 1 V 0.66 C 0.78 1, 0.21 1, 0 0.66 Z" />
        </clipPath>
      </defs>
    </svg>
    <h3>COMIENZA TU PRUEBA GRATUITA</h3>
    <p>
      Emisión de comprobantes ilimitados. No se requiere tarjeta de crédito.
      Planes de libre cancelación
    </p>
    <div class="plan__users--mobile is-hidden-tablet">
      <select
        class="select__user-mobile"
        name="user-mobile"
        id="user-mobile"
        v-model.number="actualUsers"
      >
        <option
          :value="tab.number"
          v-for="(tab, $index) of users"
          :key="`select-option-user-mobile-${$index}`"
          >{{ tab.name }}</option
        >
      </select>
      <chevron-down class="select__user-icon"></chevron-down>
    </div>
    <div class="plan__tipos--mobile is-hidden-tablet">
      <button
        class="button__plan-mobile button__plan-mobile--left"
        :class="{ 'button__plan-mobile--active': period === 'annual' }"
        @click="setYearly"
      >
        Anual
      </button>
      <button
        class="button__plan-mobile button__plan-mobile--right"
        :class="{ 'button__plan-mobile--active': period === 'monthly' }"
        @click="setMonthly"
      >
        Mensual
      </button>
    </div>
    <div class="plan__tipos is-hidden-mobile">
      <button
        class="button button--plan"
        :class="{ 'button--plan-active': monthly }"
        @click="setMonthly"
      >
        Mensual
      </button>
      <b>/</b>
      <button
        class="button button--plan"
        :class="{ 'button--plan-active': yearly }"
        @click="setYearly"
      >
        Anual
      </button>
    </div>
    <!-- <div
      class="plan__users-tabs columns is-mobile is-multiline is-hidden-mobile"
    >
      <div
        class="column is-half-mobile-only"
        v-for="(tab, $index) of users"
        :key="`user-tab-${$index}`"
      >
        <a
          role="button"
          class="user-tab"
          :class="{
            'user-tab--active': tab.number == actualUsers,
            'user-tab--button': tab.number == 9
          }"
          @click="setUserNumber(tab.number)"
        >
          {{ tab.name }}
        </a>
      </div>
    </div> -->
    <!-- <li>Prueba gratis <span @click="openModal('Prueba gratis sin costo, sin tarjetas de crédito, con emisión de comprobantes a la SUNAT hasta por 30 dias')"><information-outline /></span></li> -->
    <div class="plan__plan--mobile is-hidden-tablet">
      <slick ref="slick" :options="option">
        <div class="slidexPlan">
          <div class="slidexPlan__title bg-primary">
            <p>ContaFácil</p>
          </div>
          <div class="slidexPlan__price">
            <p v-if="paymentGrocery">
              <small>S/</small>
              <strong>{{ paymentGrocery }}</strong>
            </p>
            <p class="price-period" v-if="period === 'monthly'">
              <span>al mes</span>
            </p>
            <a
              href="https://app.contafacil.pe/#/registro"
              :disabled="!paymentGrocery"
              class="button is-rounded bg-ascend-third"
              @click="emitGlobalTriggerGtag('prueba_gratis')"
              >Prueba Gratis</a
            >
          </div>
          <div class="slidexPlan__info">
            <ul>
              <li
                @click="
                  openModal(
                    'Prueba gratis sin costo, sin tarjetas de crédito, con emisión de comprobantes a la SUNAT hasta por 30 dias',
                    'prueba_gratis'
                  )
                "
              >
                Prueba gratis
              </li>
              <li
                @click="
                  openModal(
                    'Emisión de comprobantes electrónicos en soles y dólares'
                  )
                "
              >
                Emisión de comprobantes boleta de venta electrónicas
              </li>
              <li
                @click="
                  openModal('Monitoreo de cuentas por cobrar de  clientes')
                "
              >
                Monitoreo de cuentas por cobrar
              </li>
              <!-- <li
                @click="openModal('Emisión de cotizaciones en soles y dólares')"
              >
                Emisión de cotizaciones
              </li> -->
              <li @click="openModal('Gestión de egresos del negocio')">
                Gestión de egresos
              </li>
              <li
                @click="
                  openModal('Monitoreo de cuentas por pagar a tus proveedores')
                "
              >
                Monitoreo de cuentas por pagar
              </li>
              <li @click="openModal('Monitoreo de caja de efectivo')">
                Manejo de caja de efectivo
              </li>
              <li
                @click="
                  openModal(
                    'Invita a tu contador a ContaFácil para poder ver tus reportes'
                  )
                "
                v-if="contabodega"
              >
                Invitación al contador
              </li>
              <li
                @click="openModal('Funciona en PC, MAC y Tablet')"
                v-if="contabodega"
              >
                Google Chrome
              </li>
              <li
                @click="openModal('Control de stock en  puntos de venta')"
                v-if="contabodega"
              >
                Control de inventario
              </li>
              <li
                @click="openModal('Emisión de órdenes de compra a proveedores')"
                v-if="contabodega"
              >
                Emisión de órdenes de compra
              </li>
              <li
                @click="openModal('Gestión de costo de inventario')"
                v-if="contabodega"
              >
                Gestión de costo de inventario
              </li>
              <!-- <li
                @click="openModal('Gestión de inventario por consignación')"
                v-if="contabodega"
              >
                Gestión de inventario por consignación
              </li> -->
              <li
                @click="openModal('Contenido educativo ContaFácil')"
                v-if="contabodega"
              >
                Soporte educativo
              </li>
              <li
                @click="
                  openModal(
                    'Llamadas en horarios de oficina + Chat + Correo electrónico de soporte'
                  )
                "
                v-if="contabodega"
              >
                Soporte al cliente
              </li>
            </ul>
            <a
              class="link-ver-mas"
              @click="contabodega = true"
              v-show="!contabodega"
              >Ver más ></a
            >
          </div>
        </div>
        <!-- <div class="slidexPlan">
          <div class="slidexPlan__title bg-ascend-second">
            <p>ContaServicio</p>
          </div>
          <div class="slidexPlan__price">
            <p>
              <small>S/</small>
              <strong>{{
                monthly
                  ? payments.servicio + (actualUsers - 1) * 20
                  : (payments.servicio + (actualUsers - 1) * 20) * 0.85
              }}</strong>
            </p>
            <p class="price-period"><span>al mes</span></p>
            <a
              :href="`https://app.contafacil.pe/#/registro`"
              class="button is-rounded bg-ascend-third"
              @click="emitGlobalTriggerGtag('prueba_gratis')"
              >Prueba Gratis</a
            >
          </div>
          <div class="slidexPlan__info">
            <ul>
              <li
                @click="
                  openModal(
                    'Prueba gratis sin costo, sin tarjetas de crédito, con emisión de comprobantes a la SUNAT hasta por 30 dias',
                    'prueba_gratis'
                  )
                "
              >
                Prueba gratis
              </li>
              <li
                @click="
                  openModal(
                    'Emisión de comprobantes electrónicos en soles y dólares'
                  )
                "
              >
                Emisión de comprobantes ilimitados
              </li>
              <li
                @click="
                  openModal('Monitoreo de cuentas por cobrar de  clientes')
                "
              >
                Monitoreo de cuentas por cobrar
              </li>
              <li
                @click="openModal('Emisión de cotizaciones en soles y dólares')"
              >
                Emisión de cotizaciones
              </li>
              <li @click="openModal('Gestión de egresos del negocio')">
                Gestión de egresos
              </li>
              <li
                @click="
                  openModal('Monitoreo de cuentas por pagar a tus proveedores')
                "
              >
                Monitoreo de cuentas por pagar
              </li>
              <li @click="openModal('Monitoreo de caja de efectivo')">
                Manejo de caja de efectivo
              </li>
              <li
                @click="
                  openModal(
                    'Invita a tu contador a ContaFácil para poder ver tus reportes'
                  )
                "
                v-if="contaservicio"
              >
                Invitación al contador
              </li>
              <li
                @click="openModal('Funciona en PC, MAC y Tablet')"
                v-if="contaservicio"
              >
                Google Chrome
              </li>
              <li
                @click="openModal('Contenido educativo ContaFácil')"
                v-if="contaservicio"
              >
                Soporte educativo
              </li>
              <li
                @click="
                  openModal(
                    'Llamadas en horarios de oficina + Chat + Correo electrónico de soporte'
                  )
                "
                v-if="contaservicio"
              >
                Soporte al cliente
              </li>
            </ul>
            <a
              class="link-ver-mas"
              @click="contaservicio = true"
              v-show="!contaservicio"
              >Ver más ></a
            >
          </div>
        </div>
        <div class="slidexPlan">
          <div class="slidexPlan__title bg-primary">
            <p>ContaFull</p>
          </div>
          <div class="slidexPlan__price">
            <p>
              <small>S/</small>
              <strong>{{
                monthly
                  ? payments.full + (actualUsers - 1) * 20
                  : (payments.full + (actualUsers - 1) * 20) * 0.85
              }}</strong>
            </p>
            <p class="price-period"><span>al mes</span></p>
            <a
              :href="`https://app.contafacil.pe/#/registro`"
              class="button is-rounded bg-ascend-third"
              @click="emitGlobalTriggerGtag('prueba_gratis')"
              >Prueba Gratis</a
            >
          </div>
          <div class="slidexPlan__info">
            <ul>
              <li
                @click="
                  openModal(
                    'Prueba gratis sin costo, sin tarjetas de crédito, con emisión de comprobantes a la SUNAT hasta por 30 dias',
                    'prueba_gratis'
                  )
                "
              >
                Prueba gratis
              </li>
              <li
                @click="
                  openModal(
                    'Emisión de comprobantes electrónicos en soles y dólares'
                  )
                "
              >
                Emisión de comprobantes ilimitados
              </li>
              <li
                @click="
                  openModal('Monitoreo de cuentas por cobrar de  clientes')
                "
              >
                Monitoreo de cuentas por usuario
              </li>
              <li
                @click="openModal('Emisión de cotizaciones en soles y dólares')"
              >
                Emisión de cotizaciones
              </li>
              <li @click="openModal('Gestión de egresos del negocio')">
                Gestión de egresos
              </li>
              <li
                @click="
                  openModal('Monitoreo de cuentas por pagar a tus proveedores')
                "
              >
                Monitoreo de cuentas por pagar
              </li>
              <li @click="openModal('Monitoreo de caja de efectivo')">
                Manejo de caja de efectivo
              </li>
              <li
                @click="
                  openModal(
                    'Invita a tu contador a ContaFácil para poder ver tus reportes'
                  )
                "
                v-if="contafull"
              >
                Invitación al contador
              </li>
              <li
                @click="openModal('Funciona en PC, MAC y Tablet')"
                v-if="contafull"
              >
                Google Chrome
              </li>
              <li
                @click="openModal('Control de stock en  puntos de venta')"
                v-if="contafull"
              >
                Control de inventario
              </li>
              <li
                @click="openModal('Emisión de órdenes de compra a proveedores')"
                v-if="contafull"
              >
                Emisión de órdenes de compra
              </li>
              <li
                @click="openModal('Gestión de costo de inventario')"
                v-if="contafull"
              >
                Gestión de costo de inventario
              </li>
              <li
                @click="openModal('Gestión de inventario por consignación')"
                v-if="contafull"
              >
                Gestión de inventario por consignación
              </li>
              <li
                @click="openModal('Contenido educativo ContaFácil')"
                v-if="contafull"
              >
                Soporte educativo
              </li>
              <li
                @click="
                  openModal(
                    'Llamadas en horarios de oficina + Chat + Correo electrónico de soporte'
                  )
                "
                v-if="contafull"
              >
                Soporte al cliente
              </li>
            </ul>
            <a
              class="link-ver-mas"
              @click="contafull = true"
              v-show="!contafull"
              >Ver más ></a
            >
          </div>
        </div> -->
      </slick>
      <div class="arrows">
        <img
          src="../assets/images/arrow-left.svg"
          class="arrows-prev-plan"
          alt=""
        />
        <img
          src="../assets/images/arrow-right.svg"
          class="arrows-next-plan"
          alt=""
        />
      </div>
    </div>
    <div class="plan__table container container-small is-hidden-mobile">
      <div class="table-head columns is-mobile">
        <div
          class="table-head__cell table-content__cell--description  column is-four-fifths-desktop is-four-fifths-full is-four-fifths-tablet is-hidden-mobile-only"
        ></div>
        <div
          class="table-head__cell table-content__cell--check column  bg-primary is-one-fifth"
        >
          <p>
            ContaFácil <br />
            {{
              period === "monthly"
                ? `S/ ${paymentGrocery} x Mes`
                : `S/ ${paymentGrocery}`
            }}
          </p>
          <a
            href="https://app.contafacil.pe/#/registro"
            :disabled="!paymentGrocery"
            class="button is-rounded bg-ascend-third"
            @click="emitGlobalTriggerGtag('prueba_gratis')"
            >Prueba Gratis</a
          >
        </div>
        <!-- <div
          class="table-head__cell table-content__cell--check column  bg-ascend-second is-one-fifth"
        >
          <p>
            ContaServicio <br />
            S/
            {{
              monthly
                ? payments.servicio + (actualUsers - 1) * 20
                : (payments.servicio + (actualUsers - 1) * 20) * 0.85
            }}
            x Mes
          </p>
          <a
            :href="`https://app.contafacil.pe/#!/registro`"
            class="button is-rounded bg-ascend-third"
            @click="emitGlobalTriggerGtag('prueba_gratis')"
            >Prueba Gratis</a
          >
        </div>

        <div
          class="table-head__cell table-content__cell--check column  bg-primary is-one-fifth"
        >
          <p>
            ContaFull <br />
            S/
            {{
              monthly
                ? payments.full + (actualUsers - 1) * 20
                : (payments.full + (actualUsers - 1) * 20) * 0.85
            }}
            x Mes
          </p>
          <a
            :href="`https://app.contafacil.pe/#!/registro`"
            class="button is-rounded bg-ascend-third"
            @click="emitGlobalTriggerGtag('prueba_gratis')"
            >Prueba Gratis</a
          >
        </div> -->
      </div>
      <div
        class="columns is-mobile table-content-row"
        v-for="(row, $index) in contentFirst"
        :key="`content-first-${$index}`"
      >
        <div
          class="table-content__cell table-content__cell--description column is-four-fifths-tablet"
        >
          <p>{{ row.text }}</p>
          <div
            class="plan-info-wrap"
            @mouseover="setTooltip(1, $index, true)"
            @mouseleave="setTooltip(1, $index, false)"
          >
            <div class="plan-info-tooltip" v-show="row.isTooltip">
              {{ row.popup }}
            </div>
            <information-outline />
          </div>
        </div>
        <div
          class="table-content__cell table-content__cell--check column  center"
        >
          <p v-if="row.unlimited">Boletas y Facturas de venta electrónicas</p>
          <check-svg v-else />
        </div>
        <!-- <div
          class="table-content__cell table-content__cell--check column  center"
        >
          <p v-if="row.unlimited">Todos los comprobantes ilimitados</p>
          <check-svg v-else />
        </div>

        <div
          class="table-content__cell table-content__cell--check column  center"
        >
          <p v-if="row.unlimited">Todos los comprobantes ilimitados</p>
          <check-svg v-else />
        </div> -->
      </div>
      <div class="row table-content-row separator">
        <div class="column">
          Avanzado
        </div>
      </div>
      <div
        class="columns is-mobile table-content-row"
        v-for="(row, $index) in contentSecond"
        :key="`content-second-${$index}`"
      >
        <div
          class="table-content__cell table-content__cell--description column  is-four-fifths-tablet"
        >
          <p>{{ row.text }}</p>
          <div
            class="plan-info-wrap"
            @mouseover="setTooltip(2, $index, true)"
            @mouseleave="setTooltip(2, $index, false)"
          >
            <div class="plan-info-tooltip" v-show="row.isTooltip">
              {{ row.popup }}
            </div>
            <information-outline />
          </div>
        </div>
        <div
          class="table-content__cell column table-content__cell--check  center"
        >
          <p v-if="row.unlimited">para más de 2 usuarios</p>
          <check-svg v-else />
        </div>
        <!-- <div
          class="table-content__cell column table-content__cell--check  center"
        >
          <p v-if="row.unlimited">para más de 2 usuarios</p>
          <check-svg v-else-if="row.service" />
        </div>

        <div
          class="table-content__cell column table-content__cell--check  center"
        >
          <p v-if="row.unlimited">para más de 2 usuarios</p>
          <check-svg v-else />
        </div> -->
      </div>
      <div class="row table-content-row separator">
        <div class="column">
          Soporte
        </div>
      </div>
      <div
        class="columns is-mobile table-content-row"
        v-for="(row, $index) in contentThird"
        :key="`content-third-${$index}`"
      >
        <div
          class="table-content__cell table-content__cell--description column  is-four-fifths-tablet"
        >
          <p>{{ row.text }}</p>
          <div
            class="plan-info-wrap"
            @mouseover="setTooltip(3, $index, true)"
            @mouseleave="setTooltip(3, $index, false)"
          >
            <div class="plan-info-tooltip" v-show="row.isTooltip">
              {{ row.popup }}
            </div>
            <information-outline />
          </div>
        </div>
        <div
          class="table-content__cell column table-content__cell--check  center"
        >
          <p v-if="row.unlimited">para más de 2 usuarios</p>
          <check-svg v-else />
        </div>
        <!-- <div
          class="table-content__cell column table-content__cell--check  center"
        >
          <p v-if="row.unlimited">para más de 2 usuarios</p>
          <check-svg v-else />
        </div>

        <div
          class="table-content__cell column table-content__cell--check  center"
        >
          <p v-if="row.unlimited">para más de 2 usuarios</p>
          <check-svg v-else />
        </div> -->
      </div>
      <div class="table-head table-head--foot columns is-mobile">
        <div
          class="table-head__cell table-content__cell--description column is-four-fifths-tablet is-hidden-mobile-only"
        ></div>
        <!-- <div
          class="table-head__cell table-content__cell--check column  bg-dark"
        ></div>
        <div
          class="table-head__cell table-content__cell--check column bg-ascend-second"
        ></div> -->
        <div
          class="table-head__cell table-content__cell--check column  bg-primary"
        ></div>
      </div>
    </div>
  </section>
</template>

<script>
import InformationOutline from "vue-material-design-icons/InformationOutline.vue";
import ChevronDown from "vue-material-design-icons/ChevronDown.vue";
// import CheckCircle from "vue-material-design-icons/CheckCircle.vue";
import CheckSvg from "../components/CheckSvg.vue";
import Slick from "vue-slick";
import "../../node_modules/slick-carousel/slick/slick.css";
import { EventBus } from "@/event-bus";
export default {
  name: "TablePlan",
  components: {
    InformationOutline,
    ChevronDown,
    CheckSvg,
    Slick
  },
  data() {
    return {
      contabodega: false,
      contaservicio: false,
      contafull: false,
      option: {
        infinite: true,
        dots: true,
        arrows: false,
        // prevArrow: ".arrows-prev-plan",
        // nextArrow: ".arrows-next-plan",
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              infinite: true,
              dots: true,
              arrows: true,
              prevArrow: ".arrows-prev-plan",
              nextArrow: ".arrows-next-plan"
            }
          },
          {
            breakpoint: 768,
            settings: {
              infinite: true
              // dots: true,
              // arrows: true,
              // prevArrow: ".arrows-prev-plan",
              // nextArrow: ".arrows-next-plan"
            }
          },
          {
            breakpoint: 320,
            settings: {
              infinite: true
              // dots: true,
              // arrows: true,
              // prevArrow: ".arrows-prev-plan",
              // nextArrow: ".arrows-next-plan"
            }
          }
        ]
      },
      monthly: true,
      yearly: false,
      payments: {
        bodega: 120,
        servicio: 200,
        full: 300
      },
      users: [
        {
          name: "1 usuario",
          number: 1
        },
        {
          name: "2 usuarios",
          number: 2
        },
        {
          name: "3 usuarios",
          number: 3
        },
        {
          name: "5 usuarios",
          number: 5
        },
        {
          name: "7 usuarios",
          number: 7
        },
        {
          name: "8 usuarios",
          number: 8
        },
        {
          name: "+8 Cotizar",
          number: 9
        }
      ],
      contentFirst: [
        {
          isTooltip: false,
          text: "Prueba gratis",
          popup:
            "Prueba gratis sin costo, sin tarjetas de crédito, con emisión de comprobantes a la SUNAT hasta por 30 dias",
          service: true,
          products: true,
          full: true
        },
        {
          isTooltip: false,
          text: "Emisión de comprobantes",
          // popup: "Emisión de comprobantes electrónicos en soles y dólares",
          popup: "Emisión de comprobantes electrónicos en soles",
          service: true,
          products: true,
          full: true,
          unlimited: true
        },
        {
          isTooltip: false,
          text: "Monitorea de cuentas por cobrar",
          popup: "Monitoreo de cuentas por cobrar de  clientes",
          service: true,
          products: true,
          full: true
        },
        /*{
          isTooltip: false,
          text: "Emisión de cotizaciones",
          popup: "Emisión de cotizaciones en soles y dólares",
          service: true,
          products: true,
          full: true
        },*/
        {
          isTooltip: false,
          text: "Gestión de egresos",
          popup: "Gestión de egresos del negocio",
          service: true,
          products: true,
          full: true
        },
        {
          isTooltip: false,
          text: "Monitoreo de cuentas por pagar",
          popup: "Monitoreo de cuentas por pagar a tus proveedores",
          service: true,
          products: true,
          full: true
        },
        {
          isTooltip: false,
          text: "Manejo de caja de efectivo",
          popup: "Monitoreo de caja de efectivo",
          service: true,
          products: true,
          full: true
        },
        // {

        //   service: true,
        //   products: true,
        //   full: true
        // },
        // {
        //   service: true,
        //   products: true,
        //   full: true
        // },
        {
          isTooltip: false,
          text: "Invitación al contador",
          popup:
            "Invita a tu contador a ContaFácil para poder ver tus reportes",
          service: true,
          products: true,
          full: true
        },
        {
          isTooltip: false,
          text: "Google Chrome",
          popup: "Funciona en PC, MAC y Tablet",
          service: true,
          products: true,
          full: true
        }
      ],
      contentSecond: [
        {
          isTooltip: false,
          text: "Control de inventario",
          popup: "Control de stock en  puntos de venta",
          service: false,
          products: true,
          full: true
        },
        {
          isTooltip: false,
          text: "Emisión de órdenes de compra",
          popup: "Emisión de órdenes de compra a proveedores",
          service: false,
          products: true,
          full: true
        },
        {
          isTooltip: false,
          text: "Gestión de costo de inventario",
          popup: "Gestión de costo de inventario",
          service: false,
          products: true,
          full: true
        }
        // {
        //   isTooltip: false,
        //   text: "Gestión de inventario por consignación",
        //   popup: "Gestión de inventario por consignación",
        //   service: false,
        //   products: true,
        //   full: true
        // }
        // {
        //   popup: "",
        //   service: false,
        //   products: true,
        //   full: true,
        //   unlimited: true
        // }
      ],
      contentThird: [
        {
          isTooltip: false,
          text: "Soporte educativo",
          popup: "Contenido educativo ContaFácil",
          service: true,
          products: true,
          full: true
        },
        {
          isTooltip: false,
          text: "Soporte al cliente",
          popup:
            "Llamadas en horarios de oficina + Chat + Correo electrónico de soporte",
          service: true,
          products: true,
          full: true
        }
        // {
        //   popup: "",
        //   service: false,
        //   products: true,
        //   full: true
        // },
        // {
        //   popup: "",
        //   service: false,
        //   products: true,
        //   full: true
        // }
      ],
      actualUsers: 1,
      period: "monthly",
      currentPlan: "bodega",
      textModal: "",
      paymentMap: {
        annual: 650,
        monthly: 60
      }
    };
  },
  computed: {
    pagoBodega() {
      return this.actualUsers < 3
        ? this.monthly
          ? this.payments.bodega + (this.actualUsers - 1) * 20
          : (this.payments.bodega + (this.actualUsers - 1) * 20) * 0.85
        : null;
    },
    bodegaLink() {
      return this.actualUsers < 3
        ? `https://app.contafacil.pe/#/registro?plan=bodega&users=${this.actualUsers}&period=${this.period}`
        : "";
    },
    paymentGrocery() {
      return this.paymentMap[this.period];
    }
  },
  methods: {
    emitGlobalTriggerGtag(type) {
      EventBus.$emit("triggerGtag", type);
    },
    setMonthly() {
      this.yearly = false;
      this.monthly = true;
      this.period = "monthly";
    },
    setYearly() {
      this.monthly = false;
      this.yearly = true;
      this.period = "annual";
    },
    setUserNumber(number) {
      this.actualUsers = number;
      // if (number < 15) {
      // }
    },
    setTooltip(section, index, value) {
      if (section == 1) {
        this.$set(this.contentFirst[index], "isTooltip", value);
      }
      if (section == 2) {
        this.$set(this.contentSecond[index], "isTooltip", value);
      }
      if (section == 3) {
        this.$set(this.contentThird[index], "isTooltip", value);
      }
    },
    openModal(text, typegtag) {
      if (typegtag) {
        EventBus.$emit("triggerGtag", typegtag);
      }
      this.$modal.show("tooltip-mobile-modal", text);
    },
    setModalText(event) {
      console.log(event);
      this.textModal = event.params;
    }
  }
};
</script>

<style lang="scss">
.vm--modal {
  background: transparent;
  box-shadow: none;
  // border-radius: 20px;
}
</style>
<style lang="scss" scoped>
@import "../assets/styles/colors.scss";
@import "../assets/styles/general.scss";
.mb-tb {
  margin-bottom: 8em;
}
.table-plan {
  // margin-bottom: 5rem;
  .svg-hidden {
    position: absolute;
    top: 0;
    left: -99999;
    right: 0;
    z-index: -100;
  }
  h3 {
    font-weight: normal;
    font-size: 1.2rem;
    line-height: 1.6;
    letter-spacing: 0.05em;
    margin: 2em auto;
    font-family: "Geometos", sans-serif;
  }
  p {
    font-size: 1rem;
    margin-bottom: 1em;
    letter-spacing: 0.025em;
  }
  @media (max-width: 600px) {
    padding: 0;
  }
  @include tablet() {
    // margin-bottom: 5em;
    h3 {
      // font-weight: bold;
      font-size: 25px;
      letter-spacing: 0.05em;
      margin: 2em auto;
      // font-family: Geometos;
    }
    p {
      font-size: 20px;
      // margin-bottom: 2em;
    }
  }
  @media (min-width: 1024px) {
    // margin-bottom: 5em;
    h3 {
      // font-weight: bold;
      font-size: 25px;
      letter-spacing: 0.05em;
      margin: 2em auto;
      // font-family: Geometos;
    }
    p {
      font-size: 20px;
      // margin-bottom: 2em;
    }
  }
  @media (min-width: 1400px) {
    // margin-bottom: 5em;
    h3 {
      font-size: 2rem;
      margin-bottom: 1em;
    }
    p {
      font-size: 1.6rem;
      // margin-bottom: 2em;
    }
  }
  @media (min-width: 1800px) {
    max-width: none;
    width: 80%;
    margin: 0 auto 6em;
    // margin-bottom: 5em;
    h3 {
      font-size: 3rem;
      margin-bottom: 1em;
    }
    p {
      font-size: 1.8rem;
      // margin-bottom: 2em;
    }
  }
}
.plan__tipos {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 1rem auto;
  margin-bottom: 2rem;
  width: 80%;
  .button {
    margin: 0 1rem;
    font-size: 1rem;
    width: fit-content;
    color: $dark;
    border: none;
    font-weight: 500;
    &--plan {
      &-active {
        font-weight: bold;
        color: #1fb3ac;
      }
      &:focus {
        box-shadow: none;
      }
    }
  }
  @media (max-width: 767px) {
    flex-flow: column nowrap;
    // .button {
    //   width: 100%;
    //   max-width: 240px;
    //   margin: 1rem auto;
    // }
  }
  @include tablet() {
    .button {
      // max-width: 200px;
    }
  }
  @media (min-width: 1400px) {
    width: 80%;
    .button {
      max-width: none;
      width: fit-content;
      font-size: 1.4rem;
    }
    // margin-bottom: 4rem;
  }
  @media (min-width: 1800px) {
    .button {
      max-width: none;
      width: fit-content;
      font-size: 1.4rem;
    }
    // margin-bottom: 4rem;
  }
}
.plan__tipos--mobile {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  margin: 3em auto;
  .button__plan-mobile {
    background-color: $primary;
    color: #ffffff;
    font-weight: bold;
    font-size: 1.2rem;
    padding: 0.2em 2.5em;
    border: thin solid $primary;
    border-radius: 30px;
    &:focus {
      outline: none;
    }
    &--left {
      margin-right: -40px;
      z-index: 0;
    }
    &--right {
      z-index: 0;
    }
    &--active {
      background-color: #ffffff;
      color: $accent;
      z-index: 2;
    }
  }
}
.plan__users--mobile {
  margin: 2em auto;
  position: relative;
  width: fit-content;
  .select__user-mobile {
    border-radius: 30px;
    background-color: #ffffff;
    padding: 0.2em 2em;
    position: relative;
    appearance: none;
    -webkit-appearance: none;
    &:focus {
      outline: none;
    }
  }
  .select__user-icon {
    position: absolute;
    pointer-events: none;
    right: 5px;
    top: 3px;
  }
}
.plan__users-tabs {
  max-width: 1000px;
  margin: 1rem auto !important;
  flex-flow: row wrap;
  width: 100% !important;
  @media (min-width: 767px) {
    flex-flow: row nowrap;
    justify-content: center;
  }
  @media (min-width: 1400px) {
    max-width: none;
    width: 85% !important;
  }
  @media (min-width: 1800px) {
    max-width: none;
    margin: 3rem auto !important;
  }

  .user-tab {
    // font-weight: bold;
    color: #000000;
    cursor: pointer;
    font-size: 12px;
    &--active {
      border-bottom: thick solid $primary;
    }
    &--button {
      background-color: #f1bd49;
      color: #ffffff;
      padding: 8px;
      font-weight: bold;
      border-radius: 50px;
      width: fit-content;
    }
    @media (min-width: 900px) {
      font-size: 16px;
      padding: 8px 16px;
    }
    @media (min-width: 1024px) {
      font-size: 16px;
    }
    @media (min-width: 1400px) {
      font-size: 1.2rem;
    }
    @media (min-width: 1800px) {
      font-size: 1.2rem;
      padding: 8px 16px;
      letter-spacing: 0.075em;
      &--active {
        border-bottom: 7.5px solid $primary;
      }
    }
  }
}
.plan__table {
  margin: 2rem auto;
  max-width: 1000px !important;
  @media (max-width: 600px) {
    padding: 0 !important;
  }
  @media (min-width: 1400px) {
    max-width: none !important;
    width: 80%;
  }
  @media (min-width: 1800px) {
    max-width: none !important;
  }
}
.table-head {
  height: fit-content;
  flex-flow: row wrap !important;
  margin: 0px;
  &--foot {
    height: 3rem;
    .table-content__cell--description {
      @media (max-width: 600px) {
        display: none !important;
      }
    }
  }
  &__cell {
    display: flex;
    flex-flow: column nowrap;
    justify-content: space-evenly;
    align-items: center;
    padding-top: 2em;
    padding-bottom: 1em;
    &--description {
      @media (max-width: 600px) {
        min-width: 100% !important;
      }
    }
    &--check {
      @media (max-width: 600px) {
        min-width: 33% !important;
      }
    }
    p {
      margin-bottom: 5px;
      color: #ffffff;
      font-weight: bold;
      font-size: 12px;
      line-height: 1.2;
      letter-spacing: 0.05em;
      margin-bottom: 0.5em;
    }
    .button {
      padding: 0.5em;
      height: 2rem;
      min-width: 0;
      width: fit-content;
      line-height: 1;
      margin: 0px !important;
      &[disabled] {
        background-color: #00af3b;
      }
      @media (max-width: 375px) {
        display: none;
      }
    }
    span {
      font-size: 12px;
      line-height: 1;
    }
    @include tablet() {
      p {
        font-size: 16px;
      }
    }
    @media (min-width: 1024px) {
      p {
        font-size: 1.2rem;
      }
      .button {
        font-size: 1rem;
        width: fit-content;
        padding: 0.5em;
      }
    }
    @media (min-width: 1400px) {
      p {
        font-size: 1.4rem;
      }
      .button {
        font-size: 1rem;
        width: fit-content;
        padding: 0.5em;
      }
    }
    @media (min-width: 1800px) {
      p {
        // font-size: 1.8rem;
      }
      .button {
        font-size: 1.2rem;
        width: fit-content;
        padding: 0.5em;
      }
    }
  }
}
.table-content-row {
  padding: 0.5rem 0;
  flex-flow: row wrap !important;
  margin: 0px;
  &:nth-child(2n-1) {
    background-color: #f2f2f2;
  }
  &:nth-child(2n) {
    background-color: #ffffff;
  }
}
.separator {
  background-color: #cfcfcf !important;
  & > div {
    color: #ffffff;
    text-align: start;
    font-size: 18px;
    letter-spacing: 0.05em;
    font-weight: bold;
    padding-left: 3rem;
    @media (min-width: 1400px) {
      font-size: 1.4rem;
    }
  }
}
.table-content__cell {
  display: flex !important;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  &--description {
    p {
      padding-left: 2rem;
    }
    @media (max-width: 600px) {
      min-width: 100% !important;
    }
  }
  &--check {
    @media (max-width: 600px) {
      min-width: 33% !important;
    }
  }
  p {
    color: #000000;
    margin-bottom: 0px;
    width: 85%;
    text-align: start;
    font-size: 14px;
  }
  svg {
    fill: #bcbcbc !important;
  }
  @media (min-width: 1024px) {
    p {
      font-size: 1rem;
    }
    .material-design-icon.information-outline-icon {
      font-size: 1rem;
    }
  }
  @media (min-width: 1400px) {
    p {
      font-size: 1.2rem;
    }
    .material-design-icon.information-outline-icon {
      font-size: 1.2rem;
    }
  }
  @media (min-width: 1800px) {
    p {
      font-size: 1.4rem;
    }
    .material-design-icon.information-outline-icon {
      font-size: 1.4rem;
    }
  }
}
.center {
  justify-content: center;
  p {
    text-align: center;
    font-weight: bold;
    font-size: 10px;
  }
  svg {
    fill: #32ba7c !important;
    transform: scale(0.7);
  }
  @media (min-width: 1024px) {
    p {
      font-size: 11px;
    }
    // svg {
    //   height: 4rem;
    //   width: 4rem;
    // }
  }
  @media (min-width: 1400px) {
    p {
      font-size: 0.8rem;
    }
    // svg {
    //   height: 4rem;
    //   width: 4rem;
    // }
  }
  @media (min-width: 1800px) {
    p {
      font-size: 1rem;
    }
    svg {
      height: 4rem;
      width: 4rem;
    }
  }
}
s {
  border-color: red;
}
.no-strike {
  text-decoration: none;
  color: #ffffff;
}
.button:disabled {
  background-color: transparent;
}
.info {
  cursor: help;
}
.slidexPlan {
  width: 95%;
  max-width: 280px;
  margin: 1em auto;
  border-radius: 30px;
  box-shadow: 0px 2px 5px rgba($color: #6d6e70, $alpha: 0.6);
  overflow: hidden;
  &__title {
    height: 115px;
    display: flex;
    justify-content: center;
    align-items: center;
    clip-path: url("#clipPlan");
    p {
      font-size: 1.2rem;
      color: #ffffff;
      font-weight: bold;
      margin: 0;
    }
  }
  &__price {
    p {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 2em auto;
      font-weight: bold;
      small {
        font-size: 1.5rem;
        font-weight: 500;
        margin-right: 0.5em;
      }
      strong {
        font-size: 4rem;
      }
      span {
        font-size: 1.2rem;
      }
    }
    .price-period {
      margin: 0.5em auto;
    }
  }
  &__info {
    margin: 1em auto;
    margin-bottom: 2em;
    padding: 0 1em;
    ul {
      margin-bottom: 1em !important;
      li {
        position: relative;
        padding-left: 2em;
        font-size: 14px;
        text-align: start;
        margin-bottom: 0.5em;
        &::before {
          content: " ";
          background-image: url("../assets/images/check.svg");
          background-size: cover;
          position: absolute;
          top: 3px;
          left: 0;
          width: 14px;
          height: 14px;
        }
      }
    }
    .link-ver-mas {
      text-align: center;
      padding: 0.5em 3em;
      color: #6d6e70;
      font-weight: bold;
      font-size: 12px;
      border-radius: 30px;
      box-shadow: 0px 2px 5px rgba($color: #6d6e70, $alpha: 0.6);
    }
  }
}
.plan__plan--mobile {
  position: relative;
  width: 90%;
  margin: 0 auto;
}
.plan-info-wrap {
  position: relative;
  .plan-info-tooltip {
    position: absolute;
    top: 0px;
    width: 300px;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 1rem;
    border-radius: 15px;
    background-color: #fff;
    z-index: 9;
    box-shadow: 0px 2px 5px 0px rgba($color: #606060, $alpha: 0.75);
  }
}
.modal-content {
  width: 100%;
  margin: 0px;
  padding: 1rem;
  font-size: 14px;
  border-radius: 15px;
  background-color: #ffffff;
  // box-shadow: 0 20px 60px -2px rgba(27, 33, 58, 0.4);
}
</style>
